/* eslint-disable react/no-children-prop */
import BlockComponent from "./BlockComponent";

import TextLoop from "react-text-loop";
import React from "react";
import hofPlayers from "@data/hallOfFamePlayers";

const HOF: React.FC = () => {
  let randomizeListHOFPlayers = hofPlayers
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
  return (
    <BlockComponent card centered>
      <div className="flex-col text-2xl font-bold uppercase md:flex-row md:text-3xl">
        <TextLoop className="text-redAccent" children={randomizeListHOFPlayers} /> <br className="block lg:hidden" />{" "}
        <span>était chez Deathrow.</span>
      </div>
      <p>Nous avons fait évoluer de nombreux talents depuis notre création afin de les accompagner jusqu'au plus haut niveau.</p>
    </BlockComponent>
  );
};

export default HOF;
